// extracted by mini-css-extract-plugin
export default {"root":"Pricing_root__4BzsR","form-wrap":"Pricing_form-wrap__+mbZk","rise":"Pricing_rise__3E5RR","pay":"Pricing_pay__H8VAh"};